var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "layout" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        tooltip:
                          _vm.modelValue.descripcion !== ""
                            ? _vm.modelValue.descripcion
                            : "Seleccione...",
                        readonly: "",
                        id: "item",
                        placeholder: "Producto"
                      },
                      model: {
                        value: _vm.modelValue.descripcion,
                        callback: function($$v) {
                          _vm.$set(_vm.modelValue, "descripcion", $$v)
                        },
                        expression: "modelValue.descripcion"
                      }
                    },
                    [
                      _vm._v(
                        "\n                            Producto\n                        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$modal.show("items")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      vMoney: "",
                      format: _vm.decimal,
                      id: "cantidad",
                      placeholder: "##.##"
                    },
                    model: {
                      value: _vm.modelValue.cantidad,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "cantidad", $$v)
                      },
                      expression: "modelValue.cantidad"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Cantidad\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-buttons" }, [
          _c(
            "button",
            {
              staticClass: "btn-danger btn--text",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancelar")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-ban" }),
              _c("span", [_vm._v("Cancelar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success",
              attrs: { type: "button" },
              on: { click: _vm.aceptar }
            },
            [
              _c("i", { staticClass: "fa fa-check" }),
              _c("span", [_vm._v("Aceptar")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { height: "auto", width: "70%", scrollable: "", name: "items" }
        },
        [
          _c("lista-item", {
            attrs: {
              tipoProducto: "P",
              tipo: _vm.tipo,
              searchButton: false,
              filterStatus: false,
              createButton: true
            },
            on: { selected: _vm.seleccionarItem }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [_c("h3", [_vm._v("Ítem")])])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64f94fe6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f94fe6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemGuiaRemision.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-64f94fe6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/ItemGuiaRemision.vue
// module chunks = 0